import React, { useState } from 'react';
import EventReportProduct from '@/model/EventReportProduct';
import { States } from '@/helpers/common/states';
import { ReportControllerProps } from '../../types';
import { SaleProdutContent } from './ui';
import { SaleProductProducts } from '../SaleProductProducts';
import { SaleProductSections } from '../SaleProductSections';
import { SaleProductMachine } from '../SaleProductMachine';
import { SaleProductPdv } from '../SaleProductPdv';

interface SaleDateProps {
  product: EventReportProduct;
  reportController: ReportControllerProps;
  generatePDF: () => void;
}

export const SaleProduct: React.FC<SaleDateProps> = ({
  product,
  reportController,
  generatePDF,
}) => {
  const [state, setState] = useState<States>(States.default);

  const [steps, setSteps] = useState<any[]>([
    {
      component: <SaleProductProducts reportController={reportController} setState={setState} />,
      title: 'Produtos',
      completion: true,
      status: 'current',
    },
    {
      component: <SaleProductSections reportController={reportController} setState={setState} />,
      title: 'Setores',
      completion: true,
      status: 'done',
    },
    {
      component: <SaleProductMachine reportController={reportController} setState={setState} />,
      title: 'Maquininhas',
      completion: true,
      status: 'done',
    },
    {
      component: <SaleProductPdv reportController={reportController} setState={setState} />,
      title: 'PDVs',
      completion: true,
      status: 'done',
    },
  ]);

  const handleClickStep = (step: number): void => {
    const newSteps = steps.map((s, index) => {
      if (index < step) {
        return { ...s, status: 'done' };
      }
      if (index === step) {
        return { ...s, status: 'current' };
      }
      return { ...s, status: 'todo' };
    });

    setSteps(newSteps);
  };

  return (
    <SaleProdutContent
      state={state}
      product={product}
      steps={steps}
      handleClickStep={handleClickStep}
      generatePDF={generatePDF}
    />
  );
};
